import React, { useState, useEffect } from 'react';
import { Bell, Menu, User, LogOut } from 'lucide-react';
import adminAuthService from '../../utils/adminAuthService';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_BACKEND_API;

const AdminNavbar = () => {
  const [adminName, setAdminName] = useState('Admin User');
  const [adminEmail, setAdminEmail] = useState('');
  const [showUserMenu, setShowUserMenu] = useState(false);

  useEffect(() => {
    // Fetch admin user data from API
    const fetchAdminData = async () => {
      try {
        const token = adminAuthService.getToken();
        if (!token) return;
        
        const response = await fetch(`${API_BASE_URL}/api/admin/validate-token/`, {
          method: 'GET',
          headers: {
            ...adminAuthService.authHeader()
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setAdminName(data.name || 'Admin User');
          setAdminEmail(data.email || '');
        }
      } catch (error) {
        console.error('Error fetching admin data:', error);
      }
    };
    
    fetchAdminData();
  }, []);

  const handleLogout = async () => {
    try {
      await adminAuthService.logout();
      toast.success('Successfully logged out');
    } catch (error) {
      console.error('Error during logout:', error);
      toast.error('Logout failed. Please try again.');
    }
  };

  return (
    <nav className="bg-white border-b border-gray-200 z-30">
      <div className="px-3 py-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start">
            <button type="button" className="inline-flex md:hidden mr-2">
              <Menu className="h-6 w-6" />
            </button>

            <span className="self-center text-sm font-normal sm:text-2xl whitespace-nowrap text-gray-900">
              Masho Merchant Portal
            </span>
          </div>
          <div className="flex items-center">
            {/* Notification Bell */}
            <button className="p-2 mr-1 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100">
              <Bell className="h-6 w-6" />
            </button>
            
            {/* User Menu */}
            <div className="ml-3 relative">
              <div>
                <button 
                  type="button" 
                  className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                >
                  <span className="sr-only">Open user menu</span>
                  <div className="h-8 w-8 rounded-full bg-indigo-600 flex items-center justify-center text-white">
                    <User className="h-5 w-5" />
                  </div>
                </button>
              </div>
              
              {/* Dropdown menu */}
              {showUserMenu && (
                <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="px-4 py-3">
                    <p className="text-sm text-gray-900 truncate">{adminName}</p>
                    <p className="text-sm font-medium text-gray-500 truncate">{adminEmail}</p>
                  </div>
                  <hr className="my-1" />
                  <button
                    onClick={handleLogout}
                    className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <LogOut className="mr-2 h-4 w-4" />
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;